module.exports = __webpack_public_path__ + "img/icon_noInfo.8448eedf.png";